module.exports = __webpack_public_path__ + "img/tagline.b82e6417.png";